const legalActRules = {
  label: [
    { required: true, message: 'Пожалуйста, введите краткое наименование', trigger: 'change' }
  ],
  fullLabel: [
    { required: true, message: 'Пожалуйста, введите полное наименование', trigger: 'change' }
  ],
  type: [
    { required: true, message: 'Пожалуйста, введите тип', trigger: 'change', type: 'number' }
  ],
  authorityLevel: [
    { required: true, message: 'Пожалуйста, введите уровень органа', trigger: 'change', type: 'number' }
  ],
  status: [
    { required: true, message: 'Пожалуйста, введите статус', trigger: 'change', type: 'number' }
  ],
  dateStarted: [
    { required: true, validator: (rule, value, callback) => {
        if(value)
          return callback();
        else
          return callback(new Error('Пожалуйста, введите дату начала действия'));
      }, trigger: 'change'}
  ],
  dateEdited: [],
  dateFinished: []
};

export default {
  getLegalActRules() {
    return legalActRules;
  }
}



// WEBPACK FOOTER //
// ./src/api/rules/legalact.js